import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=5a51217c&scoped=true&"
import script from "./RejectDialog.vue?vue&type=script&lang=js&"
export * from "./RejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./RejectDialog.vue?vue&type=style&index=0&id=5a51217c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51217c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
